import { useEffect, useState } from "react";
import { HandPointing } from "@phosphor-icons/react";

const KEY = "tain-scroll-hint-shown";

export function ScrollHint({ isGuest }) {
  const [show, setShow] = useState(() => isGuest || !localStorage.getItem(KEY));
  useEffect(() => {
    if (!show) return;
    localStorage.setItem(KEY, "1");
    const t = setTimeout(() => setShow(false), 5000);
    return () => clearTimeout(t);
  }, [show]);

  if (!show) return null;
  return (
    <div data-testid="feed-scroll-hint" className="pointer-events-none absolute inset-0 z-40 flex flex-col items-center justify-center gap-3">
      <div className="scroll-hint-finger rounded-full bg-sky-500/90 p-5 shadow-[0_0_40px_6px_rgba(56,189,248,0.55)] ring-4 ring-white/80">
        <HandPointing size={64} weight="fill" className="text-white" />
      </div>
      <p className="font-heading font-black text-xl text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)] tracking-tight">
        Scroll up for more
      </p>
    </div>
  );
}
